import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { registerServiceWorker } from './state/offline'
// Served from this site, not a font CDN: the privacy note promises no third
// party learns about a visit, and a CDN would.
import '@fontsource-variable/inter'
import './styles/tokens.css'
import './styles/shell.css'
import './styles/components.css'
import './styles/pages.css'
import './styles/responsive.css'
import './styles/utilities.css'
import './styles/tour.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root element is missing')

registerServiceWorker()

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
